import { CLOSE_DIALOG, OPEN_DIALOG } from '../../action-types';

export const openDialog = (scope, key, title, content, event) => ({ type: OPEN_DIALOG, scope, key, title, content, event });

export const closeDialog = (scope) => ({ type: CLOSE_DIALOG, scope });
